module.exports = __webpack_public_path__ + "img/logo.3450b071.png";